import classNames from 'classnames'
import React, { FC } from 'react'
import * as css from './List.css'

export interface ListProps {
  listClassName: string
}

const List: FC<ListProps> = ({ children, listClassName }) => {
  return <div className={classNames(css.listWrapper, listClassName)}>{children}</div>
}

export default List
